import axios from "axios";

export const state = {
    psychopatients: [],
};

export const getters = {
    psychopatients: (state) => state.psychopatients,
};

export const mutations = {
    setPsychopatients(state, newValue) {
        state.psychopatients = newValue;
    },
};

export const actions = {
    fetchPsychopatients({ commit }, params = {}) {
        return axios.get("/psycho-patients", { params }).then((res) => {
            commit("setPsychopatients", res.data.psychopatients);
        });
    },

    filterPsychopatients({ commit }, { datefrom, dateto, category_key = "" }) {
        const formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        formData.append("category_key", category_key);
        return axios.post('/psycho-patients', formData).then((res) => {
            commit("setPsychopatients", res.data.psychopatients);
        });
    },
};
